import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { GlobalUtilsService } from 'src/app/global-utils.service';
import { environment } from '../../../environments/environment';
import { FormControlName } from './contact-form-types';
import { ContactFormService } from './contact-form.service';

const estados = [
  { label: 'AC', value: 'AC' },
  { label: 'AL', value: 'AL' },
  { label: 'AP', value: 'AP' },
  { label: 'AM', value: 'AM' },
  { label: 'AC', value: 'AC' },
  { label: 'BA', value: 'BA' },
  { label: 'CE', value: 'CE' },
  { label: 'DF', value: 'DF' },
  { label: 'ES', value: 'ES' },
  { label: 'GO', value: 'GO' },
  { label: 'MA', value: 'MA' },
  { label: 'MT', value: 'MT' },
  { label: 'MS', value: 'MS' },
  { label: 'MG', value: 'MG' },
  { label: 'PA', value: 'PA' },
  { label: 'PB', value: 'PB' },
  { label: 'PR', value: 'PR' },
  { label: 'PI', value: 'PI' },
  { label: 'RJ', value: 'RJ' },
  { label: 'RN', value: 'RN' },
  { label: 'RS', value: 'RS' },
  { label: 'RO', value: 'RO' },
  { label: 'RR', value: 'RR' },
  { label: 'SC', value: 'SC' },
  { label: 'SP', value: 'SP' },
  { label: 'SE', value: 'SE' },
  { label: 'TO', value: 'TO' },
];

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss'],
})
export class ContactFormComponent {
  FormControlName = FormControlName;
  messageControlIsFocused: boolean;
  isSendingMessage: boolean;
  wasSent: boolean;
  estados = estados;

  // mediaConsumoMask = { mask: Number, normalizeZeros: false };
  mediaConsumoMask = {
    lazy: false,
    mask: 'money {(kWh)}',
    blocks: {
      money: {
        mask: Number,
        normalizeZeros: false,
      },
    },
  };

  precoKWHMask = {
    lazy: false,
    mask: '{R$} money',
    blocks: {
      money: {
        mask: Number,
        normalizeZeros: false,
      },
    },
  };

  constructor(
    public contactFormService: ContactFormService,
    public globalUtilsService: GlobalUtilsService,
    private httpClient: HttpClient
  ) {}

  messageActivationController(isFocused: boolean) {
    this.messageControlIsFocused = isFocused;
  }

  sendMessage() {
    if (this.contactFormService.form.valid) {
      this.isSendingMessage = true;
      this.contactFormService.form.disable();

      this.isSendingMessage = true;


      this.httpClient
        .post(environment.func, this.contactFormService.form.value)
        .subscribe({
          next: (res) => {
            this.wasSent = true;
            setTimeout(() => {
              this.wasSent = false;
            }, 3500);
            this.contactFormService.form.reset();
            this.contactFormService.form.enable();

            alert('Mensagem enviada com sucesso');

            this.isSendingMessage = false;
          },
          error: (err) => {
            console.error(err);
            alert(
              'Algum erro ocorreu. Tente novamente em alguns instantes ou envie um email para paraisofotovoltaico@gmail.com'
            );
            // this.contactFormService.form.reset();
            this.contactFormService.form.enable();
            this.isSendingMessage = false;
          },
        });
    } else {
      alert('Preencha todos os campos necessários');
      this.contactFormService.form.markAllAsTouched();
    }
  }
}
